import { gsap } from "gsap";
import CustomEase from "gsap/dist/CustomEase";

gsap.registerPlugin(CustomEase);

const titleInEase = CustomEase.create("custom", "0.14, 1.00, 0.34, 1.00");

const furnitureInEase = CustomEase.create(
  "furnitureInEase",
  "0.01, 0.99, 0.34, 1.00"
);

export { titleInEase, furnitureInEase };
